export const cartDataLocators = {
    minicart_estimatedsubtotal_label: 'minicart_estimatedsubtotal_label',
    minicart_setyourlocation_linktext: 'minicart_setyourlocation_linktext',
    minicart_gotocart_CTA: 'minicart_gotocart_CTA',
    minicart_checkout_CTA: 'minicart_checkout_CTA',
    minicart_dynamicprice_label: 'minicart_dynamicprice_label'
};
